var mp = mp || {};

// Slider - Hero
//-----------------------------------------------------------------
mp.sliderHero = function() {
    var $slider = $('.js_sliderHero');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        fade: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1200,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
    }); 
}





$(document).ready(function (){
    mp.sliderHero();
});